/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeriesAttributeSourceDTO
 */
export interface SeriesAttributeSourceDTO {
    /**
     * Preferred custom run identifier
     * @type {string}
     * @memberof SeriesAttributeSourceDTO
     */
    runCustomId: string;
    /**
     * Deprecated internal run UUID; use runCustomId instead
     * @type {string}
     * @memberof SeriesAttributeSourceDTO
     */
    runId: string;
}

/**
 * Check if a given object implements the SeriesAttributeSourceDTO interface.
 */
export function instanceOfSeriesAttributeSourceDTO(value: object): value is SeriesAttributeSourceDTO {
    if (!('runCustomId' in value) || value['runCustomId'] === undefined) return false;
    if (!('runId' in value) || value['runId'] === undefined) return false;
    return true;
}

export function SeriesAttributeSourceDTOFromJSON(json: any): SeriesAttributeSourceDTO {
    return SeriesAttributeSourceDTOFromJSONTyped(json, false);
}

export function SeriesAttributeSourceDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeriesAttributeSourceDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'runCustomId': json['runCustomId'],
        'runId': json['runId'],
    };
}

export function SeriesAttributeSourceDTOToJSON(value?: SeriesAttributeSourceDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'runCustomId': value['runCustomId'],
        'runId': value['runId'],
    };
}

